import { createNumberFormatter, safeFormat } from "./core";

const PERCENTAGE_UNIT = "%";

const percentFormatter = createNumberFormatter(1, { style: "percent" });
const decimalFormatter = createNumberFormatter(1);

/** 'ratio' espera 0-1. 'hundred' espera 0-100. */
type PercentScale = "ratio" | "hundred";

export function formatPercent(
  value: number | null,
  scale: PercentScale
): string {
  if (value === null || value === undefined) {
    return "-";
  }

  let finalValue = value;

  if (scale === "hundred") {
    finalValue = value / 100;
  }

  return safeFormat(finalValue, percentFormatter);
}

export function formatPercentParts(value: number | null, scale: PercentScale) {
  if (value === null || value === undefined) {
    return {
      value: "-",
      unit: PERCENTAGE_UNIT,
    };
  }

  let finalValue = value;
  if (scale === "ratio") {
    finalValue = value * 100;
  }

  const formattedValue = safeFormat(finalValue, decimalFormatter);
  return {
    value: formattedValue,
    unit: PERCENTAGE_UNIT,
  };
}
